/**
 * Care Check's public, session-independent applicant ENTRY point.
 * Never send /care/application/personal.do (that is a session-bound inner page).
 * The organisation reference must be supplied by the admin for their own tenant.
 */
export const DBS_APPLICANT_START_URL =
  'https://www.carecheck.co.uk/applicant-login/';

export function buildDBSApplicantMessage({
  firstName = '',
  organisationReference = '',
  organisationCode = '',
} = {}) {
  const reference = String(organisationReference || '').trim();
  const code = String(organisationCode || '').trim();
  const name = String(firstName || '').trim().split(/\s+/)[0] || '';
  if (!reference || reference.length > 100 || /[\r\n<>]/.test(reference)) {
    throw new Error('Enter the Care Check organisation reference for this workspace.');
  }
  if (code.length > 100 || /[\r\n<>]/.test(code)) {
    throw new Error('Enter a valid organisation code, or leave it blank.');
  }
  const greeting = name ? `Hi ${name},` : 'Hi,';
  return [
    greeting,
    '',
    'Please complete your DBS application using Care Check:',
    DBS_APPLICANT_START_URL,
    '',
    `Organisation Reference: ${reference}`,
    code ? `Organisation Code: ${code}` : 'Organisation Code: leave blank unless we have separately given you one.',
    '',
    'Enter your own details and complete the form. If the check type or any payment shown is not what we agreed for your role, please contact our recruitment team before paying.',
    'Please let us know once you have submitted the application.',
    '',
    'Thank you.',
  ].join('\n');
}
